import * as SalesOrder from "@/services/rest-api/lib/sales-order/sales-order"

import SalesOrderStatus from '@/router/views/sales-order/components/SalesOrderStatus'
import SalesOrderFormattedDate from '@/router/views/sales-order/components/SalesOrderFormattedDate'

export default {
  computed: {
    salesOrderInformationFields() {
      return [
        {
          name: 'sales_order_id',
          label: this.$t('salesOrder.field.salesOrderNumber'),
          _type: 'text',
          type: 'value-help-v2',
          placeholder: this.$t('salesOrder.placeholder.salesOrderNumber'),
          trackBy: 'id',
          displayedBy: 'number',
          listGetter: SalesOrder.get(),
          tableFields: [
            {
              key: 'number',
              label: this.$t('salesOrder.field.number'),
              isSortable: true,
            },
            {
              key: 'status.name',
              name: 'status',
              label: 'Status',
              isSortable: true,
              isSlot: true,
              slotComponent: SalesOrderStatus,
            },
            {
              key: 'sales_name',
              label: this.$t('salesOrder.field.salesName'),
              isSortable: true,
            },
            {
              key: 'customer_name',
              label: this.$t('salesOrder.field.customerName'),
              isSortable: true,
            },
            {
              key: 'reference_number',
              label: this.$t('salesOrder.field.referenceNumber'),
              isSortable: true,
            },
            {
              key: 'created_on',
              name: "created_on",
              label: this.$t('global.field.createdDate'),
              isSortable: true,
              isSlot: true,
              slotComponent: SalesOrderFormattedDate,
            },
            {
              key: 'target.picked_on',
              name: "target_picked_on",
              label: this.$t('salesOrder.field.targetPickedOn'),
              isSortable: true,
              isSlot: true,
              slotComponent: SalesOrderFormattedDate,
            },
            {
              key: 'target.delivered_on',
              name: "target_delivered_on",
              label: this.$t('salesOrder.field.targetDeliveredOn'),
              isSortable: true,
              isSlot: true,
              slotComponent: SalesOrderFormattedDate,
            },
            {
              key: 'sender.name',
              label: this.$t('salesOrder.field.senderName'),
              isSortable: true,
            },
            {
              key: 'sender.phone_number',
              label: this.$t('salesOrder.field.senderPhoneNumber'),
              isSortable: true,
            },
            {
              key: 'recipient.name',
              label: this.$t('salesOrder.field.recipientName'),
              isSortable: true,
            },
            {
              key: 'recipient.phone_number',
              label: this.$t('salesOrder.field.recipientPhoneNumber'),
              isSortable: true,
            },
            {
              key: 'total_weight',
              label: this.$t('salesOrder.field.totalWeight'),
              isSortable: true,
              formatter: (value) => value !== null ? `${this.localeThousandFormat(value)} kg` : "",
            },
            {
              key: 'total_volume',
              label: this.$t('salesOrder.field.totalVolume'),
              isSortable: true,
              formatter: (value) => value !== null ? `${this.localeThousandFormat(value)} cbm` : "",
            },
            {
              key: 'total_price',
              label: this.$t('salesOrder.field.totalPrice'),
              isSortable: true,
              thStyle: "min-width: 150px",
              formatter: (value) => value !== null ? `Rp ${this.localeThousandFormat(value)}`: ""
            },
            {
              key: 'locations',
              label: this.$t('salesOrder.field.locations'),
              isSortable: true,
              formatter: (value) => value.length > 0 ? value.join(', ') : '-'
            }
          ]
        }
      ]
    }
  }
}